import React from "react";
import { Container, Typography, Box } from "@mui/material";

const Footer = () => {
    return (
        <Box
            component="footer"
            sx={{
                marginTop: "80px",
                padding: "20px 0",
                textAlign: "center",
                backgroundColor: "transparent",
                color: "#babbbf",
            }}
        >
            <Container maxWidth="lg">
                <Typography sx={{ fontFamily: "'Inter', sans-serif", fontSize: "14px" }}>
                    © {new Date().getFullYear()} Nex. All rights reserved.
                </Typography>
            </Container>
        </Box>
    );
};




export default Footer;
